var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin01 = function SvgPin01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.212 12.212 18 14v1.5h-5.25V21l-.75.75-.75-.75v-5.5H6V14l1.789-1.789V4.5h-1V3h10.423v1.5h-1zM8.139 14h7.723l-1.15-1.15V4.5H9.289v8.35z"
  })));
};
export default SvgPin01;